<template>
  <div>
    <div id = "content-suggestions">
              <h2 class="header">Based On What You Liked:</h2>
              <NotLoggedInCard v-if="!currentUser"></NotLoggedInCard>
              <!-- for loop to iterate through the trending articles array -->
            <div class = "content-articles"  v-for="articles in displayArticles" v-bind:key="articles.articleId ?? articles.id">
            <div class="content-information-section">
              <div class="content-title-container">
              
                <div> 
                  <img :src="gridArticleThumb(articles.imageUrl)" loading="lazy" :alt="articles.title || 'Article'" />
                </div>
                <a :href="suggestionHref(articles)" @click.prevent="openSuggestion(articles)">
                  <h4 class = "content-title">{{articles.title}}</h4>
                </a>
          </div>
            </div>
            <div class="content-data">
            <h2 class = "content-category">{{ articles.category }}</h2>
            <!-- only going to show likes for trending articles -->
            <h2 class = "content-published">{{ formatPublished(articles.publishedAt) }}</h2>
          </div>
          </div>
       
            </div>
  </div>
</template>

<script>

import ArticleService from '@/services/ArticleService';
import { optimizeImage } from '@/utils/imageOptimize';
import LoggerService from '@/services/LoggerService';
import NotLoggedInCard from '@/components/NotLoggedInCard.vue';

import { mapState } from 'vuex';

export default {
  components: {
      NotLoggedInCard,

    },
  data(){
    
    return {
      contentBasedSuggestions: [],
      postClicked: 0,
      start: 0,
      end: 8
    }
  },
  async mounted(){
    //calls current pages articles
    ArticleService.listArticlesBasedOnLikes().then(response => {
      this.contentBasedSuggestions = response.data;
      console.log("user: "+ this.$store.state.user)
    }),
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    displayArticles(){
      return this.contentBasedSuggestions.slice(this.start, this.end);
    },
    ...mapState({
      currentUser: state => state.user.id,
    }),
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    gridArticleThumb(url) {
      return optimizeImage(url, 280, 158)
    },
    formatPublished(publishedAt) {
      if (!publishedAt) return '';
      const now = Date.now();
      const then = new Date(publishedAt).getTime();
      const diffMs = now - then;
      if (Number.isNaN(then) || diffMs < 0) return '';
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHr = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHr / 24);
      if (diffDay > 0) return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;
      if (diffHr > 0) return `${diffHr} hour${diffHr > 1 ? 's' : ''} ago`;
      if (diffMin > 0) return `${diffMin} minute${diffMin > 1 ? 's' : ''} ago`;
      return 'just now';
    },
    handleScroll() {
     let scrollY = window.scrollY;
     let innerHeight = window.innerHeight;
     let docHeight = document.body.offsetHeight;
     if (scrollY + innerHeight >= docHeight * 0.7) {
       this.end+=12
     }
    },
    articleRouteId(article) {
      return article?.id ?? article?.articleId;
    },
    articleRouteCategory(article) {
      if (article?.categorySpecified != null) return article.categorySpecified;
      if (article?.category != null) return article.category;
      return null;
    },
    suggestionHref(article) {
      const urlPath = article?.urlPath;
      if (typeof urlPath === 'string' && urlPath.startsWith('/')) return urlPath;
      const category = this.articleRouteCategory(article) || 'business';
      const slug = (article?.title || '')
        .toLowerCase()
        .replace(/\W+/g, '-')
        .replace(/^-|-$/g, '');
      return `/${category}/${slug}/${this.articleRouteId(article)}`;
    },
    openSuggestion(article) {
      this.postClicked = this.articleRouteId(article);
      this.logArticleClick();
      const urlPath = article?.urlPath;
      if (typeof urlPath === 'string' && urlPath.startsWith('/')) {
        this.pushToArticle(urlPath);
        return;
      }
      this.pushToArticle(this.articleRouteCategory(article), article?.title, this.articleRouteId(article));
    },
    pushToArticle(pathOrCategory, title, id){
      if (typeof pathOrCategory === 'string' && pathOrCategory.startsWith('/')) {
        if (this.$route.path !== pathOrCategory) {
          this.$router.push({ path: pathOrCategory });
        }
        return;
      }
      const category = pathOrCategory;
      const articleTitle = (title || '')
        .toLowerCase()
        .replace(/\W+/g, '-')
        .replace(/^-|-$/g, '');
      const fallbackPath = category !== null
        ? `/${category}/${articleTitle}/${id}`
        : `/business/${articleTitle}/${id}`;
      if (this.$route.path !== fallbackPath) {
        this.$router.push({ path: fallbackPath });
      }
    },
  logArticleClick(){
          //log it as an event for the recommender using the event logger
        const event = {
          user_id: this.currentUser,
          articleId: this.postClicked,
          event: `read:article`,
          sessionId: this.$store.state.sessionId
        }

        LoggerService.logger(event).then(response => {
          if(response.status == 200){

            console.log('title logged')
          } else {
            console.log('not working')
          }
        })
    },
  }

}
</script>

<style scoped>

img {
  height:  50%;
  width:  60%;
}

a{
  text-decoration: none;
}

#content-suggestions{
  background-color: #f4f1f1;
  width: 20rem;
  align-items: center;
}

@media (max-width: 913px){
    #content-suggestions{
      width: 100%;
      box-sizing: border-box;
      padding: 0 12px;
    }
  }

.header{
  height: 100%;
  margin: 0px;
  background-color: #fff;
  border: 1px solid #aaa8a8;
  font-family: 'Titillium Web', sans-serif;
}

.content-articles{
  border: 1px solid #aaa8a8;
  padding: 1em;
  flex-basis: 20%;
  animation: fadeInBottom 0.5s ease-in;
}

@keyframes fadeInBottom {
  from {
      transform: translateY(100%);
      opacity: 0;
  }
  to {
      transform: translateY(0);
      opacity: 1;
  }
}
.content-articles:hover,
  .content-articles.active{
    color: #3088d4;
    transition: border-bottom 0.3s ease, color 0.3s ease;
    transform: scale(1.01);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    opacity: 1;
    cursor: pointer;
  }

.content-title-container{
  display: flex;
  align-items: center;
  margin: 0px;
  font-family: 'Titillium Web', sans-serif;
  font-size: larger;
  font-weight: bolder;
  flex-direction: column;
  height: 90%;
  width: 100%;
}

.content-title{
  margin: 0px;
  font-size: 1.1em; /* Slightly larger font for titles */
  color: #333;
  text-decoration: none;
}

@media (max-width: 913px){
  .content-title{
    font-size: 2rem;
  }
}

.content-data{
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-evenly;
  background-color: #c0ddf7;
}

@media (max-width: 913px){
  .content-data{
    font-size: 2rem;
  }
}

.content-category{
  margin: 0px;
  font-size:medium;
}

.content-published{
  margin: 0px;
  font-size:medium;
}


</style>